var map = {
	"./DhlTermsConditions/dhl_english_terms.pdf": 78695,
	"./DhlTermsConditions/dhl_french_terms.pdf": 70447,
	"./Help/analysis.svg": 23926,
	"./Help/doctor.svg": 42151,
	"./Help/order.svg": 92509,
	"./Help/profile.svg": 41660,
	"./Manual/manual_english-version.pdf": 47744,
	"./Manual/manual_french-version.pdf": 27309,
	"./World-Health-Organization-logo.png": 41886,
	"./about_us/about-us-card1.png": 95711,
	"./about_us/about-us-header.png": 75734,
	"./about_us/cherry_background.png": 65454,
	"./about_us/doctor1.png": 98269,
	"./about_us/doctor2.png": 930,
	"./about_us/icon-maison-medicale.svg": 73148,
	"./about_us/lab.png": 46351,
	"./box3.png": 94576,
	"./claim_kit/banner.png": 20026,
	"./company_news/andrhdt-380x252.jpg": 5311,
	"./congratulation_medecin.png": 58062,
	"./dashboard/dashboard-logo-background.png": 63821,
	"./dashboard/dashboard-logo-background.svg": 65698,
	"./flags/french.svg": 44958,
	"./flags/spain.svg": 84460,
	"./flags/united_kingdom.svg": 81340,
	"./fonts/MadeCanvas/License READ ME FIRST.txt": 11708,
	"./fonts/MadeCanvas/MadeCanvas-Black.otf": 79871,
	"./fonts/MadeCanvas/MadeCanvas-Light.otf": 41361,
	"./fonts/MadeCanvas/MadeCanvas-Regular.otf": 77403,
	"./fonts/MavenPro/MavenPro-Black.otf": 32060,
	"./fonts/MavenPro/MavenPro-Bold.otf": 73071,
	"./fonts/MavenPro/MavenPro-Regular.otf": 68257,
	"./fonts/Montserrat/Montserrat-Black.ttf": 28011,
	"./fonts/Montserrat/Montserrat-BlackItalic.ttf": 2198,
	"./fonts/Montserrat/Montserrat-Bold.ttf": 37113,
	"./fonts/Montserrat/Montserrat-BoldItalic.ttf": 19485,
	"./fonts/Montserrat/Montserrat-ExtraBold.ttf": 45759,
	"./fonts/Montserrat/Montserrat-ExtraBoldItalic.ttf": 90969,
	"./fonts/Montserrat/Montserrat-ExtraLight.ttf": 81279,
	"./fonts/Montserrat/Montserrat-ExtraLightItalic.ttf": 35309,
	"./fonts/Montserrat/Montserrat-Italic.ttf": 90668,
	"./fonts/Montserrat/Montserrat-Light.ttf": 83159,
	"./fonts/Montserrat/Montserrat-LightItalic.ttf": 89608,
	"./fonts/Montserrat/Montserrat-Medium.ttf": 27048,
	"./fonts/Montserrat/Montserrat-MediumItalic.ttf": 67565,
	"./fonts/Montserrat/Montserrat-Regular.ttf": 40669,
	"./fonts/Montserrat/Montserrat-SemiBold.ttf": 73561,
	"./fonts/Montserrat/Montserrat-SemiBoldItalic.ttf": 13733,
	"./fonts/Montserrat/Montserrat-Thin.ttf": 75467,
	"./fonts/Montserrat/Montserrat-ThinItalic.ttf": 19667,
	"./fonts/Montserrat/OFL.txt": 23592,
	"./fonts/NewJune/NewJune-Book.otf": 73504,
	"./fonts/NewJune/NewJune-Heavy.otf": 73878,
	"./fonts/NewJune/NewJune-Regular.otf": 47241,
	"./fonts/Sofachrome/sofachrome rg it.ttf": 51224,
	"./fonts/Sofachrome/sofachrome rg.ttf": 79993,
	"./fonts/Sofachrome/typodermic-eula-03-2020.pdf": 93644,
	"./foods/Dandelion_greens.png": 87562,
	"./foods/MSG_rich_foods.png": 73569,
	"./foods/Nectarines.png": 52019,
	"./foods/alcohol.png": 14073,
	"./foods/algal_oil.png": 87053,
	"./foods/almonds.png": 89489,
	"./foods/amaranth.png": 93509,
	"./foods/anchovies.png": 74669,
	"./foods/apples.png": 79489,
	"./foods/apricots.png": 11930,
	"./foods/artichokes.png": 55197,
	"./foods/arugula.png": 4454,
	"./foods/asparagus.png": 63537,
	"./foods/avocadoes.png": 82775,
	"./foods/bacon.png": 84862,
	"./foods/baked_beans.png": 45454,
	"./foods/balsamic_vinegar.png": 24193,
	"./foods/bananas.png": 62965,
	"./foods/barley.png": 65629,
	"./foods/barley_flakes.png": 23080,
	"./foods/barley_rusks.png": 92114,
	"./foods/basil.png": 56361,
	"./foods/beef.png": 79729,
	"./foods/beet_greens.png": 67385,
	"./foods/beetroots.png": 48207,
	"./foods/beets.png": 68121,
	"./foods/bell_peppers.png": 43919,
	"./foods/berries.png": 74840,
	"./foods/black_grapes.png": 28166,
	"./foods/blackberries.png": 61704,
	"./foods/blackcurrants.png": 23674,
	"./foods/blueberries.png": 29343,
	"./foods/brazil_nuts.png": 46155,
	"./foods/broccoli.png": 20426,
	"./foods/brown_beans.png": 52679,
	"./foods/brussel_sprouts.png": 48737,
	"./foods/bulgur.png": 18262,
	"./foods/burdock.png": 74847,
	"./foods/burger_and_fries.png": 30025,
	"./foods/buttermilk.png": 76647,
	"./foods/cabbage.png": 4330,
	"./foods/calamari.png": 8409,
	"./foods/canned_soup.png": 84218,
	"./foods/canned_tomatoes.png": 87493,
	"./foods/canola_oil.png": 27155,
	"./foods/cantaloupe.png": 88185,
	"./foods/capers.png": 37827,
	"./foods/carrots.png": 85467,
	"./foods/cauliflower.png": 74935,
	"./foods/celery.png": 11769,
	"./foods/charred_meats.png": 30640,
	"./foods/cherries.png": 24948,
	"./foods/chia_seeds.png": 28624,
	"./foods/chicken.png": 36221,
	"./foods/chickery_roots.png": 46045,
	"./foods/chickpeas.png": 86788,
	"./foods/chicory.png": 53617,
	"./foods/chips.png": 7836,
	"./foods/cinnamon.png": 67993,
	"./foods/cloudberries.png": 15078,
	"./foods/cocoa.png": 39495,
	"./foods/coconut.png": 18219,
	"./foods/coconut_flour.png": 91751,
	"./foods/cod.png": 65011,
	"./foods/coffee.png": 31860,
	"./foods/coffee_creamer.png": 61547,
	"./foods/commercial_protein_bars.png": 96615,
	"./foods/concord_grapes.png": 19569,
	"./foods/cookies.png": 15493,
	"./foods/corn_syrup.png": 99224,
	"./foods/corned_beef.png": 19421,
	"./foods/couscous.png": 81122,
	"./foods/cranberries.png": 47446,
	"./foods/cucumbers.png": 26301,
	"./foods/cumin.png": 28323,
	"./foods/daikon_radishes.png": 81080,
	"./foods/dandelion.png": 72354,
	"./foods/dark_chocolate_over_80.png": 36875,
	"./foods/deep_fried_foods.png": 20229,
	"./foods/default_food.png": 28032,
	"./foods/deli_meats.png": 95559,
	"./foods/diet_sodas.png": 25344,
	"./foods/dill.png": 9840,
	"./foods/dried_dates.png": 72198,
	"./foods/dried_figs.png": 49591,
	"./foods/dried_fruits.png": 48851,
	"./foods/egg_pasta.png": 86878,
	"./foods/eggplant.png": 57841,
	"./foods/eggs.png": 9977,
	"./foods/elk.png": 90349,
	"./foods/endive.png": 20541,
	"./foods/energy_drinks.png": 98956,
	"./foods/extra_virgin_olive_oil.png": 71417,
	"./foods/fast_foods.png": 23837,
	"./foods/fennel.png": 48085,
	"./foods/fermented_fish.png": 8508,
	"./foods/fermented_milk.png": 45939,
	"./foods/feta_cheese.png": 11007,
	"./foods/figs.png": 50494,
	"./foods/filter_organic_coffee.png": 77334,
	"./foods/fish.png": 26622,
	"./foods/fish_n_chips.png": 8591,
	"./foods/flax.png": 54841,
	"./foods/flaxseed_oil.png": 93357,
	"./foods/flaxseeds.png": 98106,
	"./foods/food_default_img.jpg": 35445,
	"./foods/fruit_juices.png": 72137,
	"./foods/fruit_juices_in_excess.png": 13576,
	"./foods/garlic.png": 3250,
	"./foods/ginger_roots.png": 54513,
	"./foods/grapefruit.png": 35694,
	"./foods/graviera.png": 46162,
	"./foods/greek_yogurt.png": 24551,
	"./foods/green_beans.png": 40813,
	"./foods/green_peas.png": 80737,
	"./foods/green_tea.png": 95664,
	"./foods/ground_beef.png": 27327,
	"./foods/hazelnuts.png": 44751,
	"./foods/hemp_seeds.png": 42973,
	"./foods/herring.png": 10764,
	"./foods/hibiscus_tea.png": 95397,
	"./foods/high_fructose_foods.png": 29462,
	"./foods/hijiki.png": 28223,
	"./foods/honey.png": 4805,
	"./foods/horseradish.png": 24118,
	"./foods/jerusalem_artichokes.png": 5599,
	"./foods/kale.png": 73952,
	"./foods/kangaroo.png": 87547,
	"./foods/kefir.png": 36925,
	"./foods/kelp.png": 13706,
	"./foods/kiwi.png": 30108,
	"./foods/kombu.png": 23416,
	"./foods/kombucha.png": 75773,
	"./foods/konjac.png": 32916,
	"./foods/lamb.png": 3045,
	"./foods/leek.png": 85189,
	"./foods/lemon_tea.png": 65984,
	"./foods/lemons.png": 15377,
	"./foods/lentils.png": 97178,
	"./foods/lingonberries.png": 99271,
	"./foods/low_fat_cheese.png": 31967,
	"./foods/low_fat_milk.png": 26616,
	"./foods/low_sodium_salt.png": 76636,
	"./foods/macadamia_nut_butter.png": 96506,
	"./foods/mackerel.png": 99615,
	"./foods/mangoes.png": 88405,
	"./foods/margarine.png": 91041,
	"./foods/microwave_meals.png": 39316,
	"./foods/mint.png": 97161,
	"./foods/mitzithra.png": 42845,
	"./foods/mozzarella.png": 5264,
	"./foods/muesli.png": 78335,
	"./foods/mulberries.png": 99296,
	"./foods/mushrooms.png": 94820,
	"./foods/mustard.png": 77622,
	"./foods/nori.png": 9618,
	"./foods/oat.png": 85148,
	"./foods/oat_bran_rusks.png": 16411,
	"./foods/oatmeal.png": 18649,
	"./foods/octopus.png": 73760,
	"./foods/okra.png": 28348,
	"./foods/olives.png": 9698,
	"./foods/onions.png": 34935,
	"./foods/oranges.png": 58237,
	"./foods/oregano.png": 8906,
	"./foods/packaged_sweets.png": 32745,
	"./foods/palm_oil.png": 77316,
	"./foods/parmesan.png": 2581,
	"./foods/parsley.png": 37604,
	"./foods/parsnip.png": 82824,
	"./foods/pasta.png": 68027,
	"./foods/peaches.png": 88560,
	"./foods/pears.png": 96270,
	"./foods/peas.png": 39269,
	"./foods/pecans.png": 3478,
	"./foods/peppers.png": 33044,
	"./foods/persimmons.png": 15624,
	"./foods/phyllo.png": 76946,
	"./foods/pine_nuts.png": 91137,
	"./foods/pistachios.png": 62843,
	"./foods/pita_bread.png": 24653,
	"./foods/pizzas.png": 4078,
	"./foods/plantains.png": 5367,
	"./foods/plums.png": 81036,
	"./foods/pomegranate.png": 57779,
	"./foods/pork.png": 29798,
	"./foods/potato_crisps.png": 18795,
	"./foods/potatoes.png": 96185,
	"./foods/potatoes_boiled.png": 24145,
	"./foods/processed_meats.png": 91996,
	"./foods/prunes.png": 99192,
	"./foods/psyllium_seed.png": 69148,
	"./foods/pumpkin_seeds.png": 28218,
	"./foods/quinoa.png": 54616,
	"./foods/rabbit.png": 71902,
	"./foods/radish.png": 62775,
	"./foods/raspberries.png": 86759,
	"./foods/red_kidney_beans.png": 1361,
	"./foods/red_meat_in_excess.png": 81612,
	"./foods/red_onions.png": 95581,
	"./foods/red_wine.png": 88829,
	"./foods/red_wine_vinegar.png": 9418,
	"./foods/redcurrants.png": 58904,
	"./foods/refined_grains.png": 43114,
	"./foods/reindeer.png": 25535,
	"./foods/rice.png": 29919,
	"./foods/ricotta_cheese.png": 33571,
	"./foods/romaine_lettuce.png": 12660,
	"./foods/rye.png": 21730,
	"./foods/rye_bread.png": 36972,
	"./foods/salad_dressings.png": 89815,
	"./foods/salami.png": 41772,
	"./foods/salmon.png": 53333,
	"./foods/sardines.png": 96831,
	"./foods/seaweeds.png": 10224,
	"./foods/seeds_oil.png": 49877,
	"./foods/sesame_seeds.png": 3576,
	"./foods/shrimp.png": 33453,
	"./foods/snow_peas.png": 47524,
	"./foods/soy_based_meat.png": 77825,
	"./foods/soy_yogurts.png": 17029,
	"./foods/soybean.png": 5213,
	"./foods/soybean_oil.png": 62007,
	"./foods/soymilk.png": 53050,
	"./foods/spearmint_tea.png": 55242,
	"./foods/spinach.png": 93979,
	"./foods/split_peas.png": 59765,
	"./foods/spring_onions.png": 92284,
	"./foods/strawberries.png": 94473,
	"./foods/sugar_peas.png": 39253,
	"./foods/sugary_beverages.png": 10297,
	"./foods/sugary_cereals.png": 56763,
	"./foods/sundried_tomatoes.png": 50307,
	"./foods/sunflower_oil.png": 59484,
	"./foods/sweet_potatoes.png": 45541,
	"./foods/table_salt.png": 47002,
	"./foods/tahini.png": 73861,
	"./foods/tangerines.png": 24800,
	"./foods/tap_water.png": 15085,
	"./foods/tomato_paste.png": 34173,
	"./foods/tomatoes.png": 18802,
	"./foods/trout.png": 14248,
	"./foods/tuna.png": 475,
	"./foods/turkey.png": 86296,
	"./foods/turnip.png": 88140,
	"./foods/umibudo.png": 92478,
	"./foods/veal.png": 75535,
	"./foods/vinaigrette.png": 15053,
	"./foods/wakame.png": 61651,
	"./foods/walnuts.png": 23045,
	"./foods/watermelon.png": 65239,
	"./foods/wheat_bran.png": 33742,
	"./foods/wheat_bread.png": 40748,
	"./foods/white_beans.png": 28909,
	"./foods/white_bread.png": 9729,
	"./foods/white_pasta.png": 55435,
	"./foods/white_peaches.png": 93501,
	"./foods/white_potatoes.png": 22413,
	"./foods/white_sugar.png": 60797,
	"./foods/whole_grain_bread.png": 29794,
	"./foods/whole_grain_rye.png": 68773,
	"./foods/wild_caught_tuna.png": 15413,
	"./foods/wild_rice.png": 96434,
	"./foods/yacon.png": 39323,
	"./foods/yams.png": 98923,
	"./foods/yellow_beans.png": 30692,
	"./foods/yellow_split_pea.png": 38199,
	"./foods/yogurt.png": 37659,
	"./foods/zucchini.png": 22704,
	"./home/BDC1.webp": 37822,
	"./home/BDC2.webp": 17425,
	"./home/BDC3.webp": 67825,
	"./home/arrow_down.svg": 89936,
	"./home/banner.webp": 75187,
	"./home/benefices.webp": 40330,
	"./home/box.jpg": 64185,
	"./home/cadenas 1.svg": 24953,
	"./home/cadenas 2.svg": 73693,
	"./home/cancer_detection.webp": 33660,
	"./home/logo_cadenas.webp": 38528,
	"./home/microbiota_analysis.webp": 16569,
	"./home/quote_left.svg": 84882,
	"./home/quote_right.svg": 12305,
	"./how-it-works/how-it-works-banner.png": 51191,
	"./icons/card_lock.svg": 68614,
	"./icons/credit_card.svg": 37572,
	"./icons/icon-add.svg": 20751,
	"./icons/icon-arrow-left.svg": 51369,
	"./icons/icon-arrow-right.svg": 59540,
	"./icons/icon-arrow-top.svg": 42756,
	"./icons/icon-back.svg": 17259,
	"./icons/icon-check.svg": 71378,
	"./icons/icon-digest.svg": 62070,
	"./icons/icon-edit.svg": 28423,
	"./icons/icon-energy.svg": 42471,
	"./icons/icon-health.svg": 61509,
	"./icons/icon-mail.svg": 40399,
	"./icons/icon-phone.svg": 6494,
	"./icons/icon-search.svg": 93657,
	"./icons/icon-slack.png": 64705,
	"./icons/icon-stress.svg": 5043,
	"./icons/icon-weight.svg": 72044,
	"./icons/icon-whatsapp.svg": 83729,
	"./imgRegister.jpeg": 33197,
	"./locales/en/appointments": 85882,
	"./locales/en/appointments.json": 85882,
	"./locales/en/common": 9384,
	"./locales/en/common.json": 9384,
	"./locales/en/components/InsuranceTest": 81092,
	"./locales/en/components/InsuranceTest.json": 81092,
	"./locales/en/components/SubscriptionTracking": 23026,
	"./locales/en/components/SubscriptionTracking.json": 23026,
	"./locales/en/components/buyAppointment": 55084,
	"./locales/en/components/buyAppointment.json": 55084,
	"./locales/en/components/profilePicture": 14244,
	"./locales/en/components/profilePicture.json": 14244,
	"./locales/en/components/schedule": 80173,
	"./locales/en/components/schedule.json": 80173,
	"./locales/en/components/signature": 70783,
	"./locales/en/components/signature.json": 70783,
	"./locales/en/contact-us": 54619,
	"./locales/en/contact-us.json": 54619,
	"./locales/en/cookies-consent": 89218,
	"./locales/en/cookies-consent.json": 89218,
	"./locales/en/cookies-policy": 97973,
	"./locales/en/cookies-policy.json": 97973,
	"./locales/en/dashboard/common/Foods": 32854,
	"./locales/en/dashboard/common/Foods.json": 32854,
	"./locales/en/dashboard/common/SubscriptionPlanStatus": 35042,
	"./locales/en/dashboard/common/SubscriptionPlanStatus.json": 35042,
	"./locales/en/dashboard/common/UserParameters": 88902,
	"./locales/en/dashboard/common/UserParameters.json": 88902,
	"./locales/en/dashboard/company/employees": 72904,
	"./locales/en/dashboard/company/employees.json": 72904,
	"./locales/en/dashboard/company/home": 49996,
	"./locales/en/dashboard/company/home.json": 49996,
	"./locales/en/dashboard/company/invoicing": 43207,
	"./locales/en/dashboard/company/invoicing.json": 43207,
	"./locales/en/dashboard/company/kitResume": 40671,
	"./locales/en/dashboard/company/kitResume.json": 40671,
	"./locales/en/dashboard/company/order": 90015,
	"./locales/en/dashboard/company/order.json": 90015,
	"./locales/en/dashboard/company/order_kit": 56373,
	"./locales/en/dashboard/company/order_kit.json": 56373,
	"./locales/en/dashboard/company/profile": 79969,
	"./locales/en/dashboard/company/profile.json": 79969,
	"./locales/en/dashboard/doctor/allMyAppointments": 37007,
	"./locales/en/dashboard/doctor/allMyAppointments.json": 37007,
	"./locales/en/dashboard/doctor/doctorDashboard": 53145,
	"./locales/en/dashboard/doctor/doctorDashboard.json": 53145,
	"./locales/en/dashboard/doctor/history": 95458,
	"./locales/en/dashboard/doctor/history.json": 95458,
	"./locales/en/dashboard/doctor/internalChat": 23824,
	"./locales/en/dashboard/doctor/internalChat.json": 23824,
	"./locales/en/dashboard/doctor/nextAppointment": 85613,
	"./locales/en/dashboard/doctor/nextAppointment.json": 85613,
	"./locales/en/dashboard/modal-confirm-action": 43727,
	"./locales/en/dashboard/modal-confirm-action.json": 43727,
	"./locales/en/dashboard/patient/appointment": 72196,
	"./locales/en/dashboard/patient/appointment.json": 72196,
	"./locales/en/dashboard/patient/home": 43733,
	"./locales/en/dashboard/patient/home.json": 43733,
	"./locales/en/dashboard/patient/prescription": 44127,
	"./locales/en/dashboard/patient/prescription.json": 44127,
	"./locales/en/dashboard/patient/recommendations": 57682,
	"./locales/en/dashboard/patient/recommendations.json": 57682,
	"./locales/en/dashboard/patient/register-kit": 50168,
	"./locales/en/dashboard/patient/register-kit.json": 50168,
	"./locales/en/dashboard/patient/testResults": 83687,
	"./locales/en/dashboard/patient/testResults.json": 83687,
	"./locales/en/dashboard/standalone/help": 19737,
	"./locales/en/dashboard/standalone/help.json": 19737,
	"./locales/en/dashboard/standalone/profile": 30507,
	"./locales/en/dashboard/standalone/profile.json": 30507,
	"./locales/en/dashboard/support": 25805,
	"./locales/en/dashboard/support.json": 25805,
	"./locales/en/doctorPatients": 39398,
	"./locales/en/doctorPatients.json": 39398,
	"./locales/en/doctorVideoMeeting": 3186,
	"./locales/en/doctorVideoMeeting.json": 3186,
	"./locales/en/document-language-selection": 65960,
	"./locales/en/document-language-selection.json": 65960,
	"./locales/en/faq": 39292,
	"./locales/en/faq.json": 39292,
	"./locales/en/firstConnection": 89804,
	"./locales/en/firstConnection.json": 89804,
	"./locales/en/history": 84293,
	"./locales/en/history.json": 84293,
	"./locales/en/home": 5729,
	"./locales/en/home.json": 5729,
	"./locales/en/how-it-works": 72502,
	"./locales/en/how-it-works.json": 72502,
	"./locales/en/layout/footer": 12145,
	"./locales/en/layout/footer.json": 12145,
	"./locales/en/layout/header": 2261,
	"./locales/en/layout/header.json": 2261,
	"./locales/en/layout/sidebar": 60542,
	"./locales/en/layout/sidebar.json": 60542,
	"./locales/en/layout/sidebar/standalone": 59513,
	"./locales/en/layout/sidebar/standalone.json": 59513,
	"./locales/en/messaging": 32633,
	"./locales/en/messaging.json": 32633,
	"./locales/en/modals/FoodDetail": 33893,
	"./locales/en/modals/FoodDetail.json": 33893,
	"./locales/en/modals/OrderSolutionComplementary": 53408,
	"./locales/en/modals/OrderSolutionComplementary.json": 53408,
	"./locales/en/modals/shareBodyCheckup": 48251,
	"./locales/en/modals/shareBodyCheckup.json": 48251,
	"./locales/en/our-team": 45721,
	"./locales/en/our-team.json": 45721,
	"./locales/en/pages/ResetPassword": 57816,
	"./locales/en/pages/ResetPassword.json": 57816,
	"./locales/en/pages/aboutUs": 87712,
	"./locales/en/pages/aboutUs.json": 87712,
	"./locales/en/pages/downloadApp": 55693,
	"./locales/en/pages/downloadApp.json": 55693,
	"./locales/en/pages/kitRegister": 46190,
	"./locales/en/pages/kitRegister.json": 46190,
	"./locales/en/pages/login": 40638,
	"./locales/en/pages/login.json": 40638,
	"./locales/en/pages/maintenance": 97922,
	"./locales/en/pages/maintenance.json": 97922,
	"./locales/en/pages/meeting": 17733,
	"./locales/en/pages/meeting.json": 17733,
	"./locales/en/pages/notFound": 20794,
	"./locales/en/pages/notFound.json": 20794,
	"./locales/en/pages/offerKit": 93990,
	"./locales/en/pages/offerKit.json": 93990,
	"./locales/en/pages/orderSolution": 21280,
	"./locales/en/pages/orderSolution.json": 21280,
	"./locales/en/pages/ourSolution": 68543,
	"./locales/en/pages/ourSolution.json": 68543,
	"./locales/en/pages/profile": 75209,
	"./locales/en/pages/profile.json": 75209,
	"./locales/en/pages/questionnaire": 63584,
	"./locales/en/pages/questionnaire.json": 63584,
	"./locales/en/pages/register": 46319,
	"./locales/en/pages/register.json": 46319,
	"./locales/en/pages/requestReset": 35532,
	"./locales/en/pages/requestReset.json": 35532,
	"./locales/en/pages/solutionSelection": 3150,
	"./locales/en/pages/solutionSelection.json": 3150,
	"./locales/en/patientDetail": 65494,
	"./locales/en/patientDetail.json": 65494,
	"./locales/en/performance": 37553,
	"./locales/en/performance-articles": 41009,
	"./locales/en/performance-articles.json": 41009,
	"./locales/en/performance.json": 37553,
	"./locales/en/privacy": 33564,
	"./locales/en/privacy.json": 33564,
	"./locales/en/product": 71842,
	"./locales/en/product.json": 71842,
	"./locales/en/profile/doctor/address": 19717,
	"./locales/en/profile/doctor/address.json": 19717,
	"./locales/en/profile/doctor/contact": 64686,
	"./locales/en/profile/doctor/contact.json": 64686,
	"./locales/en/profile/doctor/doctor": 9616,
	"./locales/en/profile/doctor/doctor.json": 9616,
	"./locales/en/profile/doctor/myGeneralInformation": 57999,
	"./locales/en/profile/doctor/myGeneralInformation.json": 57999,
	"./locales/en/profile/doctor/mySpecialInformation": 62248,
	"./locales/en/profile/doctor/mySpecialInformation.json": 62248,
	"./locales/en/profile/doctor/profileAdditionalActions": 98699,
	"./locales/en/profile/doctor/profileAdditionalActions.json": 98699,
	"./locales/en/profile/patient/address": 82280,
	"./locales/en/profile/patient/address.json": 82280,
	"./locales/en/profile/patient/contact": 55619,
	"./locales/en/profile/patient/contact.json": 55619,
	"./locales/en/profile/patient/myGeneralInformation": 63574,
	"./locales/en/profile/patient/myGeneralInformation.json": 63574,
	"./locales/en/profile/patient/myHealthInformation": 95038,
	"./locales/en/profile/patient/myHealthInformation.json": 95038,
	"./locales/en/profile/patient/mySpecialInformation": 13820,
	"./locales/en/profile/patient/mySpecialInformation.json": 13820,
	"./locales/en/profile/patient/patient": 17744,
	"./locales/en/profile/patient/patient.json": 17744,
	"./locales/en/profile/patient/profileAdditionalActions": 11184,
	"./locales/en/profile/patient/profileAdditionalActions.json": 11184,
	"./locales/en/questionnaire": 43130,
	"./locales/en/questionnaire.json": 43130,
	"./locales/en/science": 98034,
	"./locales/en/science.json": 98034,
	"./locales/en/terms": 43408,
	"./locales/en/terms.json": 43408,
	"./locales/en/toast": 7129,
	"./locales/en/toast.json": 7129,
	"./locales/en/various/address": 21082,
	"./locales/en/various/address.json": 21082,
	"./locales/en/various/apiErrors": 70088,
	"./locales/en/various/apiErrors.json": 70088,
	"./locales/en/various/countries": 53019,
	"./locales/en/various/countries.json": 53019,
	"./locales/en/various/day": 81316,
	"./locales/en/various/day.json": 81316,
	"./locales/en/various/diet": 65800,
	"./locales/en/various/diet.json": 65800,
	"./locales/en/various/food": 60692,
	"./locales/en/various/food.json": 60692,
	"./locales/en/various/foodType": 59118,
	"./locales/en/various/foodType.json": 59118,
	"./locales/en/various/formFields": 37005,
	"./locales/en/various/formFields.json": 37005,
	"./locales/en/various/gender": 68454,
	"./locales/en/various/gender.json": 68454,
	"./locales/en/various/kit": 99914,
	"./locales/en/various/kit.json": 99914,
	"./locales/en/various/month": 62796,
	"./locales/en/various/month.json": 62796,
	"./locales/en/various/questions": 1660,
	"./locales/en/various/questions.json": 1660,
	"./locales/fr/appointments": 69022,
	"./locales/fr/appointments.json": 69022,
	"./locales/fr/common": 37811,
	"./locales/fr/common.json": 37811,
	"./locales/fr/components/InsuranceTest": 52652,
	"./locales/fr/components/InsuranceTest.json": 52652,
	"./locales/fr/components/SubscriptionTracking": 48554,
	"./locales/fr/components/SubscriptionTracking.json": 48554,
	"./locales/fr/components/buyAppointment": 35307,
	"./locales/fr/components/buyAppointment.json": 35307,
	"./locales/fr/components/profilePicture": 12105,
	"./locales/fr/components/profilePicture.json": 12105,
	"./locales/fr/components/schedule": 13589,
	"./locales/fr/components/schedule.json": 13589,
	"./locales/fr/components/signature": 35553,
	"./locales/fr/components/signature.json": 35553,
	"./locales/fr/contact-us": 73669,
	"./locales/fr/contact-us.json": 73669,
	"./locales/fr/cookies-consent": 72330,
	"./locales/fr/cookies-consent.json": 72330,
	"./locales/fr/cookies-policy": 57851,
	"./locales/fr/cookies-policy.json": 57851,
	"./locales/fr/dashboard/common/Foods": 47543,
	"./locales/fr/dashboard/common/Foods.json": 47543,
	"./locales/fr/dashboard/common/SubscriptionPlanStatus": 7248,
	"./locales/fr/dashboard/common/SubscriptionPlanStatus.json": 7248,
	"./locales/fr/dashboard/common/UserParameters": 72717,
	"./locales/fr/dashboard/common/UserParameters.json": 72717,
	"./locales/fr/dashboard/company/employees": 40348,
	"./locales/fr/dashboard/company/employees.json": 40348,
	"./locales/fr/dashboard/company/home": 65918,
	"./locales/fr/dashboard/company/home.json": 65918,
	"./locales/fr/dashboard/company/invoicing": 44146,
	"./locales/fr/dashboard/company/invoicing.json": 44146,
	"./locales/fr/dashboard/company/kitResume": 32853,
	"./locales/fr/dashboard/company/kitResume.json": 32853,
	"./locales/fr/dashboard/company/order": 51370,
	"./locales/fr/dashboard/company/order.json": 51370,
	"./locales/fr/dashboard/company/order_kit": 50316,
	"./locales/fr/dashboard/company/order_kit.json": 50316,
	"./locales/fr/dashboard/company/profile": 34267,
	"./locales/fr/dashboard/company/profile.json": 34267,
	"./locales/fr/dashboard/doctor/allMyAppointments": 45498,
	"./locales/fr/dashboard/doctor/allMyAppointments.json": 45498,
	"./locales/fr/dashboard/doctor/doctorDashboard": 21404,
	"./locales/fr/dashboard/doctor/doctorDashboard.json": 21404,
	"./locales/fr/dashboard/doctor/history": 35917,
	"./locales/fr/dashboard/doctor/history.json": 35917,
	"./locales/fr/dashboard/doctor/internalChat": 17290,
	"./locales/fr/dashboard/doctor/internalChat.json": 17290,
	"./locales/fr/dashboard/doctor/nextAppointment": 89436,
	"./locales/fr/dashboard/doctor/nextAppointment.json": 89436,
	"./locales/fr/dashboard/modal-confirm-action": 91292,
	"./locales/fr/dashboard/modal-confirm-action.json": 91292,
	"./locales/fr/dashboard/patient/appointment": 74062,
	"./locales/fr/dashboard/patient/appointment.json": 74062,
	"./locales/fr/dashboard/patient/home": 80104,
	"./locales/fr/dashboard/patient/home.json": 80104,
	"./locales/fr/dashboard/patient/prescription": 41983,
	"./locales/fr/dashboard/patient/prescription.json": 41983,
	"./locales/fr/dashboard/patient/recommendations": 67999,
	"./locales/fr/dashboard/patient/recommendations.json": 67999,
	"./locales/fr/dashboard/patient/register-kit": 28460,
	"./locales/fr/dashboard/patient/register-kit.json": 28460,
	"./locales/fr/dashboard/patient/testResults": 80505,
	"./locales/fr/dashboard/patient/testResults.json": 80505,
	"./locales/fr/dashboard/standalone/help": 88227,
	"./locales/fr/dashboard/standalone/help.json": 88227,
	"./locales/fr/dashboard/standalone/profile": 73908,
	"./locales/fr/dashboard/standalone/profile.json": 73908,
	"./locales/fr/dashboard/support": 42513,
	"./locales/fr/dashboard/support.json": 42513,
	"./locales/fr/doctorPatients": 33692,
	"./locales/fr/doctorPatients.json": 33692,
	"./locales/fr/doctorVideoMeeting": 37953,
	"./locales/fr/doctorVideoMeeting.json": 37953,
	"./locales/fr/document-language-selection": 59354,
	"./locales/fr/document-language-selection.json": 59354,
	"./locales/fr/faq": 95630,
	"./locales/fr/faq.json": 95630,
	"./locales/fr/firstConnection": 46113,
	"./locales/fr/firstConnection.json": 46113,
	"./locales/fr/history": 51455,
	"./locales/fr/history.json": 51455,
	"./locales/fr/home": 40273,
	"./locales/fr/home.json": 40273,
	"./locales/fr/how-it-works": 75560,
	"./locales/fr/how-it-works.json": 75560,
	"./locales/fr/layout/footer": 34929,
	"./locales/fr/layout/footer.json": 34929,
	"./locales/fr/layout/header": 21988,
	"./locales/fr/layout/header.json": 21988,
	"./locales/fr/layout/sidebar": 15853,
	"./locales/fr/layout/sidebar.json": 15853,
	"./locales/fr/layout/sidebar/standalone": 67021,
	"./locales/fr/layout/sidebar/standalone.json": 67021,
	"./locales/fr/messaging": 38363,
	"./locales/fr/messaging.json": 38363,
	"./locales/fr/modals/FoodDetail": 13769,
	"./locales/fr/modals/FoodDetail.json": 13769,
	"./locales/fr/modals/OrderSolutionComplementary": 7672,
	"./locales/fr/modals/OrderSolutionComplementary.json": 7672,
	"./locales/fr/modals/shareBodyCheckup": 81051,
	"./locales/fr/modals/shareBodyCheckup.json": 81051,
	"./locales/fr/our-team": 25707,
	"./locales/fr/our-team.json": 25707,
	"./locales/fr/pages/ResetPassword": 39579,
	"./locales/fr/pages/ResetPassword.json": 39579,
	"./locales/fr/pages/aboutUs": 49029,
	"./locales/fr/pages/aboutUs.json": 49029,
	"./locales/fr/pages/downloadApp": 69719,
	"./locales/fr/pages/downloadApp.json": 69719,
	"./locales/fr/pages/kitRegister": 58919,
	"./locales/fr/pages/kitRegister.json": 58919,
	"./locales/fr/pages/login": 11289,
	"./locales/fr/pages/login.json": 11289,
	"./locales/fr/pages/maintenance": 70195,
	"./locales/fr/pages/maintenance.json": 70195,
	"./locales/fr/pages/meeting": 53963,
	"./locales/fr/pages/meeting.json": 53963,
	"./locales/fr/pages/notFound": 70565,
	"./locales/fr/pages/notFound.json": 70565,
	"./locales/fr/pages/offerKit": 63322,
	"./locales/fr/pages/offerKit.json": 63322,
	"./locales/fr/pages/orderSolution": 21573,
	"./locales/fr/pages/orderSolution.json": 21573,
	"./locales/fr/pages/ourSolution": 36615,
	"./locales/fr/pages/ourSolution.json": 36615,
	"./locales/fr/pages/profile": 61163,
	"./locales/fr/pages/profile.json": 61163,
	"./locales/fr/pages/questionnaire": 45928,
	"./locales/fr/pages/questionnaire.json": 45928,
	"./locales/fr/pages/register": 72221,
	"./locales/fr/pages/register.json": 72221,
	"./locales/fr/pages/requestReset": 12204,
	"./locales/fr/pages/requestReset.json": 12204,
	"./locales/fr/pages/solutionSelection": 8492,
	"./locales/fr/pages/solutionSelection.json": 8492,
	"./locales/fr/patientDetail": 12414,
	"./locales/fr/patientDetail.json": 12414,
	"./locales/fr/performance": 91579,
	"./locales/fr/performance-articles": 37907,
	"./locales/fr/performance-articles.json": 37907,
	"./locales/fr/performance.json": 91579,
	"./locales/fr/privacy": 12043,
	"./locales/fr/privacy.json": 12043,
	"./locales/fr/product": 5954,
	"./locales/fr/product.json": 5954,
	"./locales/fr/profile/doctor/address": 61786,
	"./locales/fr/profile/doctor/address.json": 61786,
	"./locales/fr/profile/doctor/contact": 98170,
	"./locales/fr/profile/doctor/contact.json": 98170,
	"./locales/fr/profile/doctor/doctor": 4257,
	"./locales/fr/profile/doctor/doctor.json": 4257,
	"./locales/fr/profile/doctor/myGeneralInformation": 64348,
	"./locales/fr/profile/doctor/myGeneralInformation.json": 64348,
	"./locales/fr/profile/doctor/mySpecialInformation": 61035,
	"./locales/fr/profile/doctor/mySpecialInformation.json": 61035,
	"./locales/fr/profile/doctor/profileAdditionalActions": 5092,
	"./locales/fr/profile/doctor/profileAdditionalActions.json": 5092,
	"./locales/fr/profile/patient/address": 20099,
	"./locales/fr/profile/patient/address.json": 20099,
	"./locales/fr/profile/patient/contact": 40208,
	"./locales/fr/profile/patient/contact.json": 40208,
	"./locales/fr/profile/patient/myGeneralInformation": 62630,
	"./locales/fr/profile/patient/myGeneralInformation.json": 62630,
	"./locales/fr/profile/patient/myHealthInformation": 58854,
	"./locales/fr/profile/patient/myHealthInformation.json": 58854,
	"./locales/fr/profile/patient/mySpecialInformation": 79403,
	"./locales/fr/profile/patient/mySpecialInformation.json": 79403,
	"./locales/fr/profile/patient/patient": 68958,
	"./locales/fr/profile/patient/patient.json": 68958,
	"./locales/fr/profile/patient/profileAdditionalActions": 52187,
	"./locales/fr/profile/patient/profileAdditionalActions.json": 52187,
	"./locales/fr/questionnaire": 93036,
	"./locales/fr/questionnaire.json": 93036,
	"./locales/fr/science": 80214,
	"./locales/fr/science.json": 80214,
	"./locales/fr/terms": 17286,
	"./locales/fr/terms.json": 17286,
	"./locales/fr/toast": 82275,
	"./locales/fr/toast.json": 82275,
	"./locales/fr/various/address": 75971,
	"./locales/fr/various/address.json": 75971,
	"./locales/fr/various/apiErrors": 3712,
	"./locales/fr/various/apiErrors.json": 3712,
	"./locales/fr/various/countries": 99726,
	"./locales/fr/various/countries.json": 99726,
	"./locales/fr/various/day": 77299,
	"./locales/fr/various/day.json": 77299,
	"./locales/fr/various/diet": 89401,
	"./locales/fr/various/diet.json": 89401,
	"./locales/fr/various/food": 51584,
	"./locales/fr/various/food.json": 51584,
	"./locales/fr/various/foodType": 8375,
	"./locales/fr/various/foodType.json": 8375,
	"./locales/fr/various/formFields": 44401,
	"./locales/fr/various/formFields.json": 44401,
	"./locales/fr/various/gender": 55055,
	"./locales/fr/various/gender.json": 55055,
	"./locales/fr/various/kit": 53503,
	"./locales/fr/various/kit.json": 53503,
	"./locales/fr/various/month": 24434,
	"./locales/fr/various/month.json": 24434,
	"./locales/fr/various/questions": 90806,
	"./locales/fr/various/questions.json": 90806,
	"./logos/bcu_full.svg": 70530,
	"./logos/bcu_logo.png": 72214,
	"./logos/bcu_logo.svg": 53658,
	"./logos/bcu_logo_left.svg": 77966,
	"./logos/bcu_logo_right.svg": 60456,
	"./logos/bcu_logo_white.svg": 48559,
	"./logos/bcu_perf_full.png": 98207,
	"./logos/bcu_text.png": 85938,
	"./logos/bcu_white_top.svg": 63063,
	"./logos/dhl.png": 35435,
	"./maintenance.svg": 59554,
	"./map-example.png": 19370,
	"./mayo-clinic-logo.png": 65092,
	"./medication.jpeg": 90232,
	"./medication2.jpeg": 96682,
	"./meet-our-people.png": 25802,
	"./microbiome.png": 83157,
	"./not_found.svg": 83537,
	"./order-box.png": 32766,
	"./order/cancer_detection/detailed_report.png": 83176,
	"./order/cancer_detection/in_case_positive.png": 82288,
	"./order/cancer_detection/mobile_app.png": 24277,
	"./order/cancer_detection/test_kit_1.jpg": 24890,
	"./order/cancer_detection/test_kit_2.jpg": 71672,
	"./order/microbiota_analysis/detailed_report.png": 5974,
	"./order/microbiota_analysis/mobile_app.png": 91162,
	"./order/microbiota_analysis/take_care.jpg": 89639,
	"./order/microbiota_analysis/test_kit_1.png": 73108,
	"./order/microbiota_analysis/test_kit_2.png": 52944,
	"./order/microbiota_analysis/video_meeting.png": 91723,
	"./order_box_banner.png": 52908,
	"./our-mission.png": 96020,
	"./our-solution-1.png": 18778,
	"./our-solution-2.png": 97191,
	"./our-solution-3.png": 61788,
	"./our-solution-4.png": 87309,
	"./our_solution/banner.webp": 78433,
	"./our_solution/box-essai-1-solution.webp": 6189,
	"./our_solution/medecin-avec-logo.webp": 9803,
	"./our_solution/tel-avec-logo.webp": 23751,
	"./our_solution/visio-avec-logo.webp": 93759,
	"./our_team/circles_crew-en.png": 47339,
	"./our_team/circles_crew-fr.png": 31194,
	"./our_team/doctors/akeel-alisa-rond.webp": 16510,
	"./our_team/doctors/alexandre-nairi.webp": 62242,
	"./our_team/doctors/jean-luc-robert.webp": 8319,
	"./our_team/doctors/jean-michel-barbaste-cercle.webp": 65366,
	"./our_team/doctors/laure-Tourame-rond.webp": 65936,
	"./our_team/doctors/robert-arlt-cercle.webp": 47172,
	"./our_team/doctors/serge-balon.webp": 10333,
	"./our_team/leaderships/hugo.webp": 26346,
	"./our_team/leaderships/luther.webp": 29662,
	"./our_team/leaderships/philippe.webp": 24733,
	"./our_team/leaderships/tim.webp": 50320,
	"./performance/article1.webp": 42835,
	"./performance/article2.webp": 71396,
	"./performance/article3.webp": 2567,
	"./performance/article4.webp": 15480,
	"./performance/article5.webp": 75344,
	"./performance/athletics.webp": 56930,
	"./performance/foot.webp": 50220,
	"./performance/grey-logo.png": 29979,
	"./performance/rugby.webp": 19207,
	"./performance/swimming.webp": 50266,
	"./performance/tennis.webp": 78588,
	"./performance/tennis2.webp": 42323,
	"./person.png": 41641,
	"./person2.png": 60485,
	"./phone-confirmation.png": 88636,
	"./pills.svg": 12120,
	"./product_details/blue-tubes.jpeg": 66110,
	"./product_details/supplement.svg": 21349,
	"./questionnaire/data-cancer-genetics-trucheck-bild-01.jpg": 88,
	"./questionnaire/doctor-questionnaire-prepare1.png": 92853,
	"./questionnaire/doctor-questionnaire-prepare10.png": 30200,
	"./questionnaire/doctor-questionnaire-prepare11.png": 16355,
	"./questionnaire/doctor-questionnaire-prepare2.png": 38198,
	"./questionnaire/doctor-questionnaire-prepare3.png": 15164,
	"./questionnaire/doctor-questionnaire-prepare4.png": 72494,
	"./questionnaire/doctor-questionnaire-prepare5.png": 54260,
	"./questionnaire/doctor-questionnaire-prepare6.png": 63113,
	"./questionnaire/doctor-questionnaire-prepare7.png": 19872,
	"./questionnaire/doctor-questionnaire-prepare8.png": 27471,
	"./questionnaire/doctor-questionnaire-prepare9.png": 91598,
	"./questionnaire/doctor-questionnaire-slack1.png": 90921,
	"./questionnaire/doctor-questionnaire-slack2.png": 66939,
	"./questionnaire/doctor-questionnaire-slack3.png": 49409,
	"./questionnaire/doctor-questionnaire-slack4.png": 15172,
	"./rectangle.svg": 10967,
	"./science/Analyse.webp": 42109,
	"./science/banner.webp": 32825,
	"./science/blood.webp": 52002,
	"./science/cercle deux cas de figure.svg": 96768,
	"./science/laboratoire.webp": 1112,
	"./science/salivary.webp": 39558,
	"./science/urinary.webp": 88675,
	"./symptoms-background.png": 25173,
	"./teamWorking.png": 16586,
	"./test-analysis.svg": 14111,
	"./test-rectangle.svg": 35183,
	"./test.svg": 94895,
	"./tubes.jpeg": 96124,
	"./undraw_No_data.svg": 68494,
	"./video/animated-logo.gif": 55546,
	"./video/home-banner-video.mp4": 6744,
	"./video/home-video.m4v": 1006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;